import { render, staticRenderFns } from "./smsStatistics.vue?vue&type=template&id=6f52563a"
import script from "./smsStatistics.vue?vue&type=script&lang=js"
export * from "./smsStatistics.vue?vue&type=script&lang=js"
import style0 from "./smsStatistics.vue?vue&type=style&index=0&id=6f52563a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports